import DragAndDropFileComponent from "@_common/file-drag-drop";
import {
  vendorFileUpload,
  vendorUploadSubmitCheckpointLocation,
} from "@services/checkpoint.service";
import { getValue } from "@utils/lodash";
import * as React from "react";
import { toast } from "react-toastify";
import { Modal, ModalBody } from "reactstrap";

interface ReportsUploadModalProps {
  isOpen: boolean;
  handleModal: () => void;
  getData: () => void;
  vendorInfo: object;
  mainParams: any;
  selectedIndex: any;
  handleSubmitTask: (id: any, releaseCycleId: any) => void;
  //   releaseCycleIds: any;
}

const ReportsUploadModal: React.FunctionComponent<ReportsUploadModalProps> = (
  props
) => {
  const { mainParams } = props;
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [uploadLoading, setUploadLoading] = React.useState(false);
  const [uploadedDocuments, setUploadedDocuments] = React.useState<any>([]);
  const [submitLoading, setSubmitLoading] = React.useState(false);

  const handleUploadDocumnets = async (e: any) => {
    const files = Array.from(e);

    setUploadLoading(true);

    try {
      for (const item of files) {
        try {
          const formData = new FormData();
          formData.append("file", item as any);

          const resp = await vendorFileUpload(formData);

          if (resp) {
            uploadedDocuments.push(getValue(resp, `data`, {}));
          }
        } catch (error) {
          console.error("Upload error:", error);
        }
      }
    } finally {
      e = null;
      setUploadedDocuments([...uploadedDocuments]);
      setUploadLoading(false);
    }
  };

  const fileTypes = [
    "PDF",
    "JPEG",
    "XLSX",
    "CSV",
    "XLSM",
    "XLX",
    "JPG",
    "PNG",
    "DOC",
    "DOCX",
  ];

  console.log(getValue(props, `vendorInfo`, ""), "---vendorInfo--->");

  const handleSubmit = async () => {
    let uploadIds =
      getValue(uploadedDocuments, `length`, 0) > 0
        ? uploadedDocuments.map((item: any) => item.id)
        : [];
    try {
      setSubmitLoading(true);
      let payload = {
        vendor_checkpoint: [
          {
            id: getValue(props, `vendorInfo.id`, ""),
            audit_cycle_id: getValue(props, `releaseCycleIds`, ""),
            document_ids: getValue(uploadIds, `length`, 0) > 0 ? uploadIds : [],
          },
        ],
      };
      let resp = await vendorUploadSubmitCheckpointLocation(payload);
      if (resp) {
        setSubmitLoading(false);
        props.handleModal();
        props.getData();
        toast.success("Uploaded successfully");
      } else {
        props.getData();
        setSubmitLoading(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  // const handleSubmitTask = async () => {
  //     try {
  //         setSubmitLoading(true);

  //         let payload = {
  //             ids: props.selectedIndex,
  //             audit_status: "PENDING_AUDIT",
  //           };

  //     } catch (error) {

  //     }
  // }
  return (
    <>
      <div className="attach-files-wrapper">
        <Modal
          isOpen={getValue(props, `isOpen`, "")}
          toggle={getValue(props, `isOpen`, "")}
          centered
          size="lg"
        >
          <div className="attach-files-wrapper__title-section d-flex justify-content-between">
            <h3 className="attach-files-wrapper__title">Attach File</h3>
            <div className="d-flex justify-content-end">
              {/* <button
							className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
							onClick={() => props.handleModal()}
						>
							Cancel
						</button> */}
              <img
                src="/images/close-red.svg"
                className="cursor-pointer"
                width={25}
                onClick={props.handleModal}
              />
            </div>
          </div>
          <ModalBody>
            <div>
              <div>
                <h6 className="comments-popup__vendor-name">Task ID</h6>
                <p className="comments-popup__vendor-text">
                  {getValue(props, `vendorInfo.task_id`, "")}
                </p>
              </div>
              <div className="comments-popup__vendor-details">
                <h6 className="comments-popup__vendor-name">Legislation</h6>
                <p className="comments-popup__vendor-text">
                  {getValue(
                    props,
                    `vendorInfo.checkpoint.legislation.legislation_name`,
                    ""
                  )}
                </p>
              </div>
            </div>
            <div>
              {uploadLoading ? (
                <label className="input-file-label w-100 text-center cursor-pointer mb-4">
                  <input
                    // type={'file'}
                    // onChange={handleUploadDocumnets}
                    multiple
                    className="d-none"
                  />
                  <div className="custom-inputfile">
                    <img
                      src="/images/input-file.png"
                      className="img-fluid mb-2"
                      height={40}
                      width={40}
                    />
                    <p className="custom-inputfile__text">Please wait...</p>
                  </div>
                </label>
              ) : (
                <div className="input-file-label w-100 text-center cursor-pointer mb-4">
                  <DragAndDropFileComponent
                    uploadFile={handleUploadDocumnets}
                    name="file"
                    types={fileTypes}
                    multiple
                    // className="d-none"
                    classes="bulk-upload_drag-n-drop-wrapper position-absolute"
                  />
                </div>
              )}
              {getValue(uploadedDocuments, `length`, 0) > 0 && (
                <div className="d-flex justify-content-between">
                  <div></div>
                  <div className="d-flex">
                    {submitLoading ? (
                      <button className="ascent-button ascent-button--header-buttons ascent-button--primary">
                        Please wait...
                      </button>
                    ) : (
                      <button
                        className="ascent-button ascent-button--header-buttons ascent-button--primary"
                        onClick={handleSubmit}
                        disabled={
                          getValue(uploadedDocuments, `length`, 0) === 0
                        }
                      >
                        {"Save Uploaded files"}
                      </button>
                    )}
                    {getValue(props, "vendorInfo.audit_status", "") !==
                      "PENDING_AUDIT" && (
                      <button
                        className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center ms-3"
                        onClick={() => {
                          handleSubmit();
                          props.handleSubmitTask(
                            getValue(props, `vendorInfo.id`, ""),
                            getValue(props, `releaseCycleIds`, "")
                          );
                        }}
                        disabled={
                          getValue(mainParams, `listenable`, "") === "0"
                        }
                      >
                        Submit for Audit Review
                      </button>
                    )}
                  </div>
                </div>
              )}
              {getValue(uploadedDocuments, `length`, 0) > 0 && (
                <div className="mb-3">
                  <h3 className="attach-files-wrapper__select">
                    Select from uploaded files
                  </h3>
                  {getValue(uploadedDocuments, `length`, 0) > 0 ? (
                    uploadedDocuments.map((item: object, key: number) => {
                      return (
                        <div
                          key={key}
                          className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                        >
                          <p>
                            {getValue(item, `name`, "")}
                            {getValue(item, `extension`, "")}
                          </p>
                          <div>
                            <img
                              src="/images/close-black.svg"
                              className="img-fluid cursor-pointer"
                              //   onClick={() => handleRemoveUploadedFiles(key)}
                            />
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-center mt-2"> No Data Found</p>
                  )}
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default ReportsUploadModal;
